import Main from '@/components/main'
import parentView from '@/components/parent-view'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      hideInMenu: true
    },
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/',
    name: '_home',
    redirect: '/home',
    component: Main,
    meta: {
      hideInMenu: false,
      notCache: true
    },
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          hideInMenu: false,
          title: '首页',
          notCache: true,
          icon: 'md-home'
        },
        component: () => import('@/view/home/home')
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/login/login.vue')
  },

  // 企业管理
  {
    path: '/company',
    name: 'company',
    meta: {
      title: '企业管理'
    },
    component: Main,
    children: [
      // 机构管理
      {
        path: 'organization',
        name: 'organization',
        meta: {
          title: '企业管理',
          icon: 'md-bookmark'
        },
        component: parentView,
        children: [
          {
            path: 'organization-manage',
            name: 'organization-manage',
            meta: {
              title: '机构列表',
              icon: 'md-bookmark'
            },
            component: () => import('@/view/organization-manage/organization-manage')
          },
          {
            path: 'add-organization',
            name: 'add-organization',
            meta: {
              title: '添加机构',
              hideInMenu: true
            },
            component: () => import('@/view/organization-manage/add-organization')
          },
          {
            path: 'organization-config',
            name: 'organization-config',
            meta: {
              title: '机构配置',
              activeName: 'organization-manage'
            },
            component: () => import('@/view/organization-manage/organization-config')
          },
          {
            path: 'permission-config',
            name: 'permission-config',
            meta: {
              title: '权限分类',
              activeName: 'organization-manage'
            },
            component: () => import('@/view/organization-manage/permission-config')
          }
        ]
      },
      {
        path: 'permission-manage',
        name: 'permission-manage',
        meta: {
          title: '权限管理'
        },
        component: parentView,
        children: [
          {
            path: '',
            name: 'permission-manage',
            meta: {
              title: '权限列表'
            },
            component: () => import('@/view/company/permission-manage/permission-manage')
          },
          {
            path: 'add-permission',
            name: 'add-permission',
            meta: {
              title: '添加权限'
            },
            component: () => import('@/view/company/permission-manage/add-permission')
          },
          {
            path: 'permission-role-manage',
            name: 'permission-role-manage',
            meta: {
              title: '角色管理'
            },
            component: () => import('@/view/company/permission-manage/role-manage')
          }
        ]
      },
      {
        path: 'menu-group',
        name: 'menu-group',
        meta: {
          title: '菜单权限组'
        },
        component: parentView,
        children: [
          {
            path: '',
            name: 'menu-group',
            meta: {
              title: '菜单权限组'
            },
            component: () => import('@/view/company/menu-group/menu-group.vue')
          }
        ]
      }
    ]
  },
  // 管理员管理
  {
    path: '/admin',
    name: 'admin',
    meta: {
      title: '管理员',
      icon: 'md-person'
    },
    component: Main,
    children: [
      {
        path: 'admin-manage',
        name: 'admin-manage',
        meta: {
          title: '管理员列表'
        },
        component: () => import('@/view/admin-manage/admin-manage')
      },
      {
        path: 'add-admin',
        name: 'add-admin',
        meta: {
          title: '添加管理员',
          hideInMenu: true,
          activeName: 'admin-manage'
        },
        component: () => import('@/view/admin-manage/add-admin')
      },
      {
        path: 'auth-manage',
        name: 'auth-manage',
        meta: {
          title: '菜单列表'
        },
        component: () => import('@/view/admin-manage/auth/auth-manage')
      },
      {
        path: 'add-auth',
        name: 'add-auth',
        meta: {
          title: '添加菜单',
          hideInMenu: true,
          activeName: 'auth-manage'
        },
        component: () => import('@/view/admin-manage/auth/add-auth')
      },
      {
        path: 'agency-auth-manage',
        name: 'agency-auth-manage',
        meta: {
          title: '机构菜单列表'
        },
        component: () => import('@/view/admin-manage/agency-auth/agency-auth-manage')
      },
      {
        path: 'add-agency-auth',
        name: 'add-agency-auth',
        meta: {
          title: '添加机构菜单',
          hideInMenu: true,
          activeName: 'agency-auth-manage'
        },
        component: () => import('@/view/admin-manage/agency-auth/add-agency-auth')
      },
      {
        path: 'role-manage',
        name: 'role-manage',
        meta: {
          title: '角色列表'
        },
        component: () => import('@/view/admin-manage/role/role-manage')
      },
      {
        path: 'add-role',
        name: 'add-role',
        meta: {
          title: '添加角色',
          hideInMenu: true,
          activeName: 'role-manage'
        },
        component: () => import('@/view/admin-manage/role/add-role')
      }
    ]
  },
  // 系统配置
  {
    path: '/',
    meta: {
      title: '系统配置',
      icon: 'md-settings',
      hideInBread: true
    },
    component: Main,
    children: [
      {
        path: 'system',
        name: 'system',
        meta: {
          title: '系统配置',
          icon: 'md-settings'
        },
        component: () => import('@/view/system/system')
      }
    ]
  },
  // 线索管理
  {
    path: '/contact',
    name: 'contact',
    meta: {
      title: '线索管理'
    },
    component: Main,
    children: [
      {
        path: '',
        name: 'contact',
        meta: {
          title: '线索管理',
          icon: 'md-people',
          hideInBread: true
        },
        component: () => import('@/view/contact/contact')
      }
    ]
  },
  // 保险广告
  {
    path: '/insurance',
    name: 'insurance',
    meta: {
      title: '保险广告'
    },
    component: Main,
    children: [
      {
        path: '',
        name: 'insurance-ad-list',
        meta: {
          title: '保险广告列表',
          icon: 'md-people',
          hideInBread: true
        },
        component: () => import('@/view/insurance/insurance-ad-list')
      }
    ]
  },
  {
    path: '/403',
    name: 'error_403',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/403.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/500.vue')
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/404.vue')
  }
]
